import _                           from 'underscore';
import React, { ReactNode }        from 'react';
import { Align, SemanticUIColor }  from '../types';
import { BasicDialog }             from '../views/components/modals/BasicDialog';
import { BasicDialogContainer }    from '../views/components/modals/BasicDialogContainer';
import { HelpAndSupportStatement } from '../views/components/util/messaging/HelpAndSupportStatement';
import { useSystemModals }         from './useSystem';
import { useUserSnapTools }        from './useUserSnap';
import { Header }                  from 'semantic-ui-react';
import { CORVAL_SUPPORT_EMAIL }    from '../constants/SystemEnums';
import { mailTo }                  from '../util';

type PromptHandler = ( message: ReactNode, onSubmitHandler: () => void ) => void;

interface UsePrompts {
	confirmAbandonChanges: PromptHandler
	
	promptSupportActions(): void
}

type UsePromptsHook = () => UsePrompts

export const usePrompts: UsePromptsHook = () => {
	
	let modalActions                    = useSystemModals(),
	    { invokeUserSnap, hasUserSnap } = useUserSnapTools();
	
	const confirmAbandonChanges: UsePrompts['confirmAbandonChanges'] = ( message = null, onSubmitHandler = null ) => {
		
		modalActions.show( (
			
			<BasicDialog
				onSubmit={ onSubmitHandler }
				onComplete={ () => { modalActions.toggle( false ) } }
				className={ 'no-padding' }
				submitLabel={ 'OK' }
				cancelLabel={ 'Cancel' }
				successToastLabel={ null }
				errorToastLabel={ null }>
				
				<BasicDialogContainer title={ 'Abandon Changes?' } titleColor={ SemanticUIColor.ORANGE }>
					{ _.isString( message ) ? <p>{ message }</p> : message }
					<p><strong>Are you sure you want to proceed?</strong></p>
				</BasicDialogContainer>
			
			</BasicDialog>
		), {
			size: 'tiny'
		} );
	}
	
	const promptSupportActions: UsePrompts['promptSupportActions'] = () => {
		
		// Do something with support service...
		const handleCreateSupportTicket = () => {
			
			if( hasUserSnap() ){
				
				// Show
				invokeUserSnap();
				
			} else {
				
				mailTo( CORVAL_SUPPORT_EMAIL )
			}
			
			modalActions.toggle( false )
		}
		
		modalActions.show( (
			
			<BasicDialog
				onSubmit={ handleCreateSupportTicket }
				onComplete={ () => { modalActions.toggle( false ) } }
				className={ 'no-padding' }
				submitLabel={ hasUserSnap() ? 'Send Feedback' : 'Contact Support' }
				cancelLabel={ 'Close' }
				successToastLabel={ null }
				errorToastLabel={ null }>
				
				<BasicDialogContainer title={ 'Corval Support' } titleColor={ SemanticUIColor.PURPLE }>
					<Header as={ 'h4' }>We are here to assist you!</Header>
					<p>In order to help support our customers, you can direct inquiries to our support email{ hasUserSnap() ? `, or you can send us detailed information about the platform through our feedback report` : '' }.</p>
					<p>Please <HelpAndSupportStatement withInlineCasing={ true } contactName={ 'Corval Support' } withClickableLink={ true }/></p>
				</BasicDialogContainer>
			
			</BasicDialog>
		), {
			size: 'tiny'
		} );
	}
	
	return {
		confirmAbandonChanges,
		promptSupportActions
	};
};
